<template>
	<CardGrafico
		:title="$t('farms')"
		:subtitle="dataDoUltimoProcessamento"
	>
		<template #botoes>
			<ButtonDropdown
				v-model="dropdownTipoGrafico"
				:label="$t('totalVolume')"
				color="trv-default"
				semantic-class="mini"
				:options="[
					{ label: $t('totalVolume'), value: 'volumeTotal' },
					{ label: $t('averageVolume'), value: 'volumeMedio' },
					{
						label: $t('aai'),
						value: 'incrementoMedioAnual',
					},
				]"
				outlined
			/>
			<!-- <ButtonDropdown
        style="margin-top: 0.5rem"
        color="trv-neutral"
        :label="$t('download')"
        semanticClass="mini"
        :options="[
          { label: 'PNG', value: 'image/png' },
          { label: 'JPEG', value: 'image/jpeg' },
          { label: 'PDF', value: 'application/pdf' },
          { label: 'SVG', value: 'image/svg+xml' },
          { label: '.csv', value: 'text/csv' },
        ]"
        v-model="dropdownDownload"
        outlined
      /> -->
		</template>
		<template #grafico>
			<Loading v-if="data.length === 0" />
			<div
				v-else
				class="container__graficofazenda"
			>
				<Chart
					ref="ref__chart"
					class="container__graficofazenda__grafico"
					:options="chartOptions"
				/>
				<div class="container__graficofazenda__filtro">
					<FiltroGraficoFazenda
						:dados-do-filtro="filtroFazendas"
						:propriedade-selecionada="dropdownTipoGrafico"
						@filterClick="esconderOuMostrarFazenda"
						@selecionarTodas="selecionarTodasFazendas"
					/>
				</div>
			</div>
		</template>
	</CardGrafico>
</template>

<script>
import { Chart } from 'highcharts-vue'
import ButtonDropdown from '../../../../../components/ButtonDropdown/ButtonDropdown'
import Loading from '../../../../../components/Loading/Loading'
import CardGrafico from '../../CardGrafico'
import FiltroGraficoFazenda from './FiltroGraficoFazenda/FiltroGraficoFazenda'

import { getColorHexByCSSVariable } from '../../../../../utils/themesHelper'
import { stringToExportCSV } from '../../../../../utils/csvHellpers'

import _ from 'lodash'

import randomcolor from 'randomcolor'

import i18n from '../../../../../VueI18n'

/**
 * Quantidade de fazendas exibidas por padrao no grafico (top N pela metrica selecionada)
 */
const QUANTIDADE_PADRAO_EXIBIDA = 10

export default {
	components: {
		ButtonDropdown,
		CardGrafico,
		Chart,
		FiltroGraficoFazenda,
		Loading,
	},
	props: {
		/**
		 * Dados que devem ser passados para o componente
		 */
		data: {
			type: Array,
			required: true,
		},

		/**
		 * Data do ultimo processamento
		 */
		dataDoUltimoProcessamento: { type: String, require: true },
	},
	data() {
		return {
			chartOptions: {
				chart: {
					type: 'area',
				},
				/**
				 * Creditos no canto inferior direito do grafico
				 */
				credits: {
					enabled: false,
				},
				/**
				 * Não usar exportacao padrao do highcharts
				 */
				exporting: {
					enabled: false,
				},
				/**
				 * Deasbilitar legendas
				 */
				legend: {
					enabled: false,
				},
				/**
				 * Opcoes na hora de plotar o grafico
				 */
				plotOptions: {
					series: {
						/**
						 * Animacao de 2 segundos
						 */
						animation: {
							duration: 1000,
						},
					},
				},
				/**
				 * Dados que devem ser colocados no grafico
				 */
				series: [],
				/**
				 * Titulo do grafico
				 */
				title: {
					text: '',
				},
				/**
				 * Balão ao passar o mouse sobre as barras
				 */
				tooltip: {
					formatter: function () {
						let result = `
              <div class="container__graficofazenda__tooltip">
                  <div class="container__graficofazenda__tooltip__fazenda">
                      <div class="container__graficofazenda__tooltip__fazenda__nome"> ${this.point.options.fazenda.nome}</div> <br/>
                      <div class="container__graficofazenda__tooltip__fazenda__info"> 
                        <span>${i18n.t('idadeDosPlantios')}</span> 
                        <span>${this.point.options.fazenda.idade} ${i18n.t('years')}</span>
                      </div>
                      <div class="container__graficofazenda__tooltip__fazenda__info"> 
                        <span>${i18n.t('totalVolume')}</span> 
                        ${this.point.options.fazenda.volumeTotal} (m³)
                      </div> 
                      <div class="container__graficofazenda__tooltip__fazenda__info"> 
                        <span>${i18n.t('averageVolume')}</span> 
                        ${this.point.options.fazenda.volumeMedio} (m³/ha) 
                      </div> 
                      <div class="container__graficofazenda__tooltip__fazenda__info"> 
                        <span>Incremento Médio Anual</span> 
                        ${this.point.options.fazenda.incrementoMedioAnual} ${i18n.t('ano')}
                      </div>
                  </div> 
              </div>`

						return result
					},
					backgroundColor: '#333647',
					borderRadius: 10,
					borderWidth: 0,
					outside: true,
					shadow: false,
					useHTML: true,
				},
				/**
				 * Eixo X
				 */
				xAxis: {
					allowDecimals: false,
					title: {
						text: this.$t('idadeAno'),
						style: {
							fontFamily: 'Open Sans, sans-serif',
							fontSize: '.8rem',
							fontWeight: 600,
						},
					},
					labels: {
						style: {
							color: '#01395e',
							fontFamily: 'Open Sans, sans-serif',
							fontSize: '.8rem',
							fontWeight: 700,
						},
					},
				},
				/**
				 * Eixo Y
				 */
				yAxis: {
					title: {
						text: 'Volume',
						style: {
							fontFamily: 'Open Sans, sans-serif',
							fontSize: '.8rem',
							fontWeight: 600,
						},
					},
					gridLineColor: 'rgba(var(--color-rgb-gray), .2)',
					labels: {
						style: {
							color: '#01395e',
							fontFamily: 'Open Sans, sans-serif',
							fontSize: '.8rem',
							fontWeight: 700,
						},
					},
				},
			},
			/**
			 * Diferentes series para serem aplicados quando selecionar o filtro
			 */
			allSeries: [],
			/**
			 * Tipo do gráfico que deve ser exibido
			 */
			dropdownTipoGrafico: '',
			/**
			 * Opção selecionada para o download
			 */
			dropdownDownload: '',
			/**
			 * Filtro para esconder ou mostrar dados da fazenda no grafico
			 */
			filtroFazendas: [],
			/**
			 * Filtro do inputSearch
			 */
			textFilter: '',
		}
	},
	computed: {
		/**
		 * Configuracao do grafico de acordo com o tipo exibido
		 */
		tipoDoGrafico() {
			if (this.dropdownTipoGrafico === 'volumeTotal') {
				return this.$t('volumeTotal')
			} else if (this.dropdownTipoGrafico === 'volumeMedio') {
				return this.$t('volumeMedio')
			} else {
				return this.$t('ima2')
			}
		},
	},
	watch: {
		/**
		 * Sempre que o data mudar ira renderizar o grafico novo
		 */
		data() {
			this.allSeries = []
			this.filtroFazendas = []
			this.setarObjetosParaOGrafico()
			this.dropdownTipoGrafico = 'volumeTotal'
			this.recalcularSelecaoTop10()
			this.changeHighchartsOptions()
		},

		/**
		 * Seta o novo serie para o highchart, recalculando o top 10 da nova metrica
		 */
		dropdownTipoGrafico() {
			this.recalcularSelecaoTop10()
			this.changeHighchartsOptions()
		},

		/**
		 * Seleciona a opcao de download escolhida
		 */
		dropdownDownload(type) {
			if (type) {
				const filename = `${new Date().getTime()}`
				if (type === 'text/csv') {
					const csv = this.$refs.ref__chart.chart.getCSV()
					stringToExportCSV(filename, csv)
				} else {
					this.$refs.ref__chart.chart.exportChart({ filename, type })
				}
				this.dropdownDownload = ''
			}
		},
	},
	methods: {
		/**
		 * Adiciona serie que são os dados que o highcharts precisa para renderizar o grafico
		 */
		addToAllSeries(historicoFazenda, propriedade, color) {
			const fazenda = historicoFazenda[0].nome

			const serie = {
				color,
				data: [],
				dataLabels: {
					enabled: true,
					format: `{y}`,
					style: {
						fontFamily: 'Open Sans, sans-serif',
						fontWeight: 400,
						fontSize: '0.75rem',
					},
				},
				id: fazenda,
			}

			historicoFazenda.forEach((fazenda) => {
				serie.data.push({
					x: fazenda.idade,
					y: fazenda[propriedade],
					fazenda,
					plantios: fazenda.plantios,
				})
			})

			this.allSeries.push({ fazenda, propriedade, serie })
		},
		/**
		 * Adiciona a legenda para o grafico, sendo possivel filtrar o grafico atraves das legendas
		 */
		addFiltroFazenda(historicoFazenda, color) {
			historicoFazenda = _.orderBy(historicoFazenda, 'idade', 'desc')

			const filtroFazenda = {
				color,
				isChecked: true,
				label: historicoFazenda[0].nome,
				volumeMedio: parseFloat(historicoFazenda[0].volumeMedio.toFixed(2)),
				volumeTotal: parseFloat(historicoFazenda[0].volumeTotal.toFixed(2)),
				incrementoMedioAnual: parseFloat(historicoFazenda[0].incrementoMedioAnual.toFixed(2)),
			}

			this.filtroFazendas.push(filtroFazenda)
		},
		/**
		 * Metodo que vai iterar sobre o data para criar os objetos necessarios
		 * para o componente do Gráfico e do Filtro
		 */
		setarObjetosParaOGrafico() {
			const agrupadoPorFazenda = _.groupBy(this.data, (data) => data.id)

			const rgbDefaultColor = getColorHexByCSSVariable('--color-default')
			const rgbPrimaryColor = getColorHexByCSSVariable('--color-primary')
			let colorThemeRandom = 0

			Object.values(agrupadoPorFazenda).forEach((historicoFazenda) => {
				historicoFazenda = _.orderBy(historicoFazenda, 'idade', 'asc')

				const color =
					colorThemeRandom % 2 === 0
						? randomcolor({
								luminosity: 'bright',
								format: 'rgb',
								hue: rgbDefaultColor,
							})
						: randomcolor({
								luminosity: 'dark',
								format: 'rgb',
								hue: rgbPrimaryColor,
							})

				this.addToAllSeries(historicoFazenda, 'volumeTotal', color)
				this.addToAllSeries(historicoFazenda, 'volumeMedio', color)
				this.addToAllSeries(historicoFazenda, 'incrementoMedioAnual', color)

				this.addFiltroFazenda(historicoFazenda, color)
				colorThemeRandom++
			})
		},
		/**
		 * Marca como selecionadas apenas as primeiras N fazendas (top N) pela metrica
		 * atualmente selecionada e desmarca as demais
		 */
		recalcularSelecaoTop10() {
			const ordenadasPelaMetrica = _.orderBy(
				this.filtroFazendas,
				[this.dropdownTipoGrafico],
				['desc'],
			)

			ordenadasPelaMetrica.forEach((fazenda, index) => {
				fazenda.isChecked = index < QUANTIDADE_PADRAO_EXIBIDA
			})
		},
		/**
		 * Seta serie para o Highcharts, exibindo apenas as fazendas selecionadas (isChecked)
		 */
		changeHighchartsOptions() {
			const fazendasSelecionadas = new Set(
				this.filtroFazendas.filter((f) => f.isChecked).map((f) => f.label),
			)

			const series = this.allSeries
				.filter((f) => f.propriedade === this.dropdownTipoGrafico)
				.map((m) => ({ ...m.serie, visible: fazendasSelecionadas.has(m.fazenda) }))

			this.chartOptions.series = series
			this.chartOptions.yAxis.title.text = this.tipoDoGrafico
		},
		/**
		 * Evento de click no filtro do grafico
		 */
		esconderOuMostrarFazenda({ label: nomeDaFazenda, isChecked: isVisible }) {
			const serie = this.$refs.ref__chart.chart.get(nomeDaFazenda)
			if (!serie) {
				return
			}
			if (isVisible) {
				serie.show()
			} else {
				serie.hide()
			}
		},
		/**
		 * Seleciona ou desmarca todas as fazendas de uma vez, refletindo no grafico.
		 * A atualizacao e feita em lote com um unico redraw (sem animacao) para nao travar
		 * o navegador, e os dataLabels sao desligados quando ha muitas series visiveis
		 * (ficam ilegiveis e o calculo de colisao do Highcharts e custoso).
		 */
		selecionarTodasFazendas(selecionar) {
			const chart = this.$refs.ref__chart.chart

			this.filtroFazendas.forEach((fazenda) => {
				fazenda.isChecked = selecionar
			})

			const exibirDataLabels = !selecionar
			chart.series.forEach((serie) => {
				serie.update({ visible: selecionar, dataLabels: { enabled: exibirDataLabels } }, false)
			})

			chart.redraw(false)
		},
	},
}
</script>

<style scoped>
.container__graficofazenda {
	display: grid;
	grid-template-areas: 'filtro' 'grafico';
	grid-template-columns: [grafico] 100% [filtro] 100%;
}

.container__graficofazenda__grafico {
	grid-area: grafico;
}
.container__graficofazenda__filtro {
	grid-area: filtro;
	max-height: 150px;
	display: flex;
	flex-direction: column;
}

@media screen and (min-width: 992px) {
	.container__graficofazenda {
		grid-template-areas: 'grafico filtro';
		grid-template-columns: [grafico] 3fr [filtro] 1fr;
		min-height: 400px;
	}

	.container__graficofazenda__filtro {
		margin-left: 1rem;
		max-height: unset;
	}
}
</style>

<style>
.container__graficofazenda__tooltip {
	padding: 10px 10px 0 10px;
	line-height: 1rem;
	font-family: 'Open Sans', sans-serif;
	font-size: 0.75rem;
	color: white;
}

.container__graficofazenda__tooltip__fazenda {
	margin-bottom: 10px;
	padding-bottom: 10px;
}

.container__graficofazenda__tooltip__fazenda__nome {
	font-size: 1rem;
	display: flex;
	justify-content: center;
}

.container__graficofazenda__tooltip__fazenda__info {
	display: flex;
	justify-content: space-between;
}

.container__graficofazenda__tooltip__fazenda__info > span:first-child {
	color: var(--color-gray);
	margin-right: 0.5rem;
}
</style>
